<template>
  <div v-html="text" class="doc"></div>
</template>

<script>
export default {
  data() {
    return {
      text: `《隐私保护政策》Ver1.0</br>
更新日期：2023年12月29日</br></br>
应用软件 中升GO 是一款由 上海中升购企业管理有限公司 提供的产品。 </br>
如对本《隐私政策》或相关事宜有任何问题，请通过 联系电话：0411-39798888 与我们联系。</br>

特别提示：</br>
中升GO（中升GO APP、微信小程序、微信公众号以及其他平台经营者，以下简称“中升GO”或“我们”）非常注重保护用户（以下或称“您”）的个人信息及隐私，鉴于您在使用我们的服务时，为帮助您充分了解我们如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择，特制定本《中升GO隐私保护政策》（以下或称“本政策”）。</br></br>
在使用中升GO各项产品或服务前，请您务必仔细阅读并透彻理解本政策（特别是加粗或下划线的内容），在确认充分理解并同意后使用相关产品或服务。如您对本政策有任何疑问，您可以通过本政策载明的联系方式和我们联系</br>
本隐私权政策部分将帮助您了解以下内容：</br>
1、 适用范围及定义</br>
2、 用户信息的收集和使用</br>
3、 Cookie关联公司及类似技术的使用</br>
4、 用户信息的共享、转让和公开披露</br>
5、 用户个人信息的保护</br>
6、 用户个人信息的保存、跨境传输、删除、访问和管理</br>
7、 未成年人信息保护</br>
8、 其他</br></br>
1、 适用范围及定义</br>
1.1本政策适用于中升GO以APP、小程序、公众号以及随技术发展出现的新形态向您提供的各项产品和服务。 如我们所提供的产品或服务设有单独的隐私政策或相应的用户服务协议当中存在特殊约定，则该产品或服务的隐私政策或用户协议优先适用，但对于该产品或服务的隐私政策和用户协议未涵盖的内容，以本政策内容为准。如果我们及关联公司提供的产品或服务中使用了中升GO提供的产品或服务但未设置独立的隐私政策的，则本政策同样适用于该部分产品或服务。</br>
1.2除本政策说明的相关信息收集适用活动外，本政策不适用于中升GO平台商家及第三方向您提供的产品或服务，其他产品或服务适用其向您另行说明的个人信息收集使用规则。</br>
1.3您理解并同意，中升GO有权根据业务发展的需要单方修订本政策，并在相应页面发布，修订后的版本将完全替代修订前的版本。请您及时关注和了解本政策的修订情况，若您不同意修订后版本，您应立即停止使用中升GO服务，否则即视同您同意并完全接受修订后的版本。</br>
1.4本政策所称的个人信息是指，以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。单独的设备信息、日志信息、搜索关键词信息以及其他无法与特定个人直接建立联系的信息或数据，不属于个人信息。</br>
1.5.本政策所称的个人敏感信息是指，一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下(含)儿童信息等。</br>
1.6.本政策所称的关联公司是指，一方直接或间接控制、共同控制另一方；以及两方或两方以上受同一主体控制、共同控制的公司。前述“控制”是指，直接或间接拥有的权力，从而通过行使表决权、合同或其他方式决定或影响某一方的经营管理或战略决策。</br></br>
2、 用户信息的收集和使用</br>
我们在此提醒您，因我们向您提供的产品和服务种类众多，且不同用户选择使用的产品或服务范围存在差异，故对应收集使用的个人信息类型、范围会存在区别，您个人信息的实际收集和使用情况请您以所享受的产品和服务情况为准。</br>
2.1. 您须授权我们收集和使用您个人信息的情形</br>
我们会遵循正当、合法、必要的原则，出于以下目的，收集和使用您在使用产品与服务过程中主动提供或因使用产品与服务而产生的个人信息。用以向您提供产品与服务、优化我们的产品与服务及保障您的账号安全。我们也会根据您的中升GO平台账户使用情况及平台设置的会员等级计算规则确定您当前的会员等级，并为您提供相应会员等级所对应的基本权益。</br>
1) 为识别您的设备ID并预防恶意程序及反作弊、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息(包括IMEI、MEID、Android ID、IMSl、GUID、MAC地址)、您安装的应用信息或运行中的进程信息。</br>
2) 为保障我们服务的稳定运行、功能实现，使您能够使用和享受更多的功能及服务，我们的服务中会接入由合作方提供的软件开发工具包（SDK）、应用程序接口（API）。我们会对合作方获取信息的软件开发工具包（SDK）、应用程序接口（API）进行严格的安全检测，并与合作方约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。我们接入的合作方详情如下，我们建议您阅读相关的隐私政策：第三方的SDK目录。</br>
3) 为对应用错误异常进行监控，以及对平台进行优化升级，我们将收集应用软件运行异常信息。</br>
4) WiFi扫描行为，运用到一键登录功便于用户快速登录提升作体验、人验识别功能需要取得WF状本结果，进行合同签署、使用定位功自时需获取Wi6状
态进行精准定位
2.1.1. 用户注册及登录</br>
<span>您使用本人<strong>手机号码</strong><span>注册成为中升GO用户时，我们将通过发送短信验证码的方式来验证您的身份是否有效。如使用微信等第三方账户登录中升GO时，我们会根据您的授权获取您在第三方的账户信息（包括头像、昵称、地区和性别信息），以帮助您登录并使用中升GO，保护您的账户安全。若您不提供上述信息，您将无法在中升GO兑换商品或购物，但您仍可匿名浏览或搜索商品。</br>
2.1.2. 展示商品/服务</br>
<span>为向您提供更稳定的产品服务，我们会收集和使用您在访问或使用中升GO时的<strong>设备信息、日志信息及浏览、搜索记录</strong>，以及其他取得您授权的信息，用于异常数据的跟踪分析，仅作为异常问题跟踪时分析触发机制使用，不做任何其他用途。具体而言：<span></br>
<span>(1) 设备信息：包括<strong>设备类型、设备型号、MAC地址及IMEl、ANDROID ID、OAID、设备设置、设备识别码、设备存储空间、移动应用列表等软硬件特征信息、操作系统和应用程序版本、语言设置、分辨率、服务商提供网络ID(PLMN)、设备所在位置相关信息（包括您授权的GPS位置信息以及WLAN接入点、蓝牙和基站传感器信息）、浏览器类型</strong>。此外，中升GO可能会写入您访问或使用中升GO时所使用的设备的存储空间。</span></br>
<span>(2) 日志信息：在您访问或使用中升GO时，系统可能会自动接收并记录您的<strong>浏览器、计算机上的信息（包括但不限于 IP地址、浏览器类型、搜索记录、浏览记录、浏览习惯、使用的语言、访问日期和时间、电信运营商及记录您需求的网页记录）</strong>。</span></br>
2.1.3. 交易及售后</br>
(1）订单信息</br>
<span>当您在中升GO进行积分兑换或购买商品/服务时，系统会生成您积分兑换或购买该商品/服务的订单。您需在订单中至少填写收货人姓名（或名称）、收货地址及电话号码，该订单会同时载明订单号、您所兑换或购买的商品/服务信息、下单时间、您实际支付的货款金额及您采用的支付方式。根据部分商品/服务的特点及适用法律的要求，您可能还需提供相关身份信息（如您的<strong>身份证、军官证、护照、港澳台通行证、驾驶证、社保卡、学生证或相关证件号码）、电子邮箱、您本人的照片或视频</strong>，如您不兑换/不购买/不使用某些商品/服务，则无需提供相关信息。</span></br>
您理解并同意，我们将使用您的订单信息来进行您的身份核验、确定交易、支付结算，为您查询订单，提供客服咨询与售后服务等；我们可能还会使用您的订单信息来判断您的交易是否存在异常以保障您的交易安全。</br>
(2）支付信息</br>
<span>在您下单后，为完成订单支付，您需要提供您的<strong>支付账户信息</strong>并选择付款方式，我们会将您的中升GO平台用户名、对应的支付账户用户名、订单支付相关信息与支付服务机构(商业银行或第三方支付机构)共享。如您选择由金融机构为您提供支付服务的，我们还会将您的包括<strong>银行卡号、有效期在内的银行卡支付必要信息</strong>与您选择的相应金融机构共享。如果您选择使用中升GO积分进行支付或兑换商品/服务的，我们还会获取您的积分信息并帮助您完成相关商品/服务的兑换或订单支付。以实现其确认您的支付指令并完成支付。</span></br>
(3) 配送信息</br>
为向您交付您兑换或购买的商品，我们需将您的配送信息提供给相应的物流配送主体。</br>
(4)客服与售后服务所需信息</br>
为向您提供客服与售后服务，我们会使用您的账户信息和订单信息，以核验您的身份或查询您的订单。为记录或解决您提出的相关问题，我们可能会保存您与我们的沟通、通信/通话记录，您可能会在与我们的客服沟通时，提供您的联系方式、商品照片等其他信息，以协助客服人员完成您所要求的服务。</br>
(5) 商品评价等信息</br>
您可通过我们为您提供的评论、晒单分享及其他信息发布功能公开发布信息，包括作为会员可发布图文、发表评价及问答内容。我们可能会根据您的会员类型及网络日志信息判断您是否可享受对应功能权限。您公开发布的信息可能会涉及您的个人信息甚至个人敏感信息，请您慎重选择是否发布，如您公开发布的信息涉及其他人的个人信息或个人敏感信息，请务必征得他人的事先同意。如您不提供前述信息，不会影响您使用中升GO平台提供的其他服务。</br>
2.1.4为提高您使用中升GO产品及服务的安全性，保障您、其他用户的人身财产安全，更准确地预防网络安全及欺诈等风险，我们可能会通过您的账户信息、交易信息、设备信息、日志信息、浏览及搜索记录浏览习惯等信息，来判断您的账户及交易风险，验证身份、检测及防范安全事件，并依法采取必要的记录、分析、审计、处置措施。</br>
2.2用户可选择是否授权收集、使用的信息</br>
为向您提供更加优质、满意的服务，努力提升您的用户体验我们可能会附加收集和使用您的信息。若您不提供这些信息，您依然可以获得中升GO为您提供的服务，但您可能无法获得这些附加信息给您带来的用户体验。</br>
<span>2.2.1 位置信息：我们可能会收集您的<strong>位置信息</strong>来判断您所处的地点，辅助判断当客诉发生时的交易地点（我们仅收集您当时所处的地理位置，不会将您不同时段的位置信息进行联系、结合以判断您的行踪轨迹）。</span></br>
2.2.2 摄像头（相机）相册（图片库）信息：您可以在中升GO上传照片或图片来晒单、发表评论信息，我们可能会通过您所上传的照片或图片来识别您需要兑换或购买的商品或服务，或使用包含您所上传照片或图片的评论信息。若中升GO服务支持您使用人脸识别登录或进行身份验证时，我们会收集您的面部信息。</br>
2.2.3媒体资料库信息：平台会不定期组织线上积分互动活动，部分活动需要用户上传媒体资料信息参与互动。</br>
2.2.4. 麦克风（语音）信息：为更好地使用中升GO服务，您可能会启用麦克风与我们、中升GO商家或其他主体沟通，我们可能会收集您的语音信息以识别您的需求。</br>
2.2.5. 联系人信息：我们可能会收集您的联系人信息以方便您在兑换或购买商品或服务时无须手动输入您的联系人信息。在获得您同意的情况下或符合法律法规规定的情况下，我们可能会判断您的联系人是否同为中升GO用户，以在中升GO为你们的交流建立联系。</br>
2.2.6. 日历信息：我们将收集您的日历信息用于向您提供兑换或购物或领取权益相关记录及提醒。</br>
2.2.7. 存储权限：我们向您申请获取此权限，以保障产品及服务的稳定运行。在获得您同意的情形，我们可能会从您的设备存储空间内读取或向其中写入图片、文件、崩溃日志信息等必要信息，以向您提供信息发布或在本地记录崩溃日志信息等功能。</br>
2.2.8.读取电话状态：我们向您申请获取此权限，以正常识别您的本机识别码，以便完成安全风控、进行统计和服务推送。</br>
2.2.9.拨打电话权限：您可以在开启拨打电话权限后使用该功能用于拨打我们的客服电话或拨打电话获得售后支持。</br>
2.2.10.应用使用情况：我们会在您开启应用使用情况权限后，检测手机内是否有对APP造成损害以及造成APP内数据泄漏的应用，并提示您，以保证使用安全。</br>
<span>2.2.11. 您理解并同意，在上述情形下，我们可能需要您在您的设备中开启您的<strong>地理位置（位置信息）、摄像头（相机）、相册（图片库)、麦克风（语音）、通讯录以及日历等访问权限</strong>，以实现这些权限所涉及信息的收集和使用。您可在您的设备中逐项查看上述权限的状态，并可自行决定这些权限的开启或关闭（如适用）。当您开启任一权限即代表您授权我们收集和使用该项信息来实现对应目标。您一旦关闭任一权限即代表您取消了授权，我们将不再继续收集和使用该项个人信息，也无法为您实现该授权所对应目标。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息的收集、处理与使用。</span></br>

2.3.征得授权同意的例外</br>
您充分知晓，根据相关法律法规之规定，以下情形中，我们收集、使用您的个人信息无须征得您的授权同意：</br>
2.3.1. 与我们履行法律法规规定的义务相关的；</br>
2.3.2. 与国家安全、国防安全直接相关的；</br>
2.3.3. 与公共安全、公共卫生、重大公共利益直接相关的；</br>
2.3.4. 与刑事侦查、起诉、审判和判決执行等直接相关的；</br>
2.3.5. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</br>
2.3.6. 所收集的个人信息是您自行向社会公众公开的；</br>
2.3.7. 根据您的要求签订和履行合同所必需的；</br>
2.3.8. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</br>
2.3.9. 维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务故障；</br>
2.3.10. 新闻单位依法收集个人信息后，为开展合法的新闻报道所必需的；</br>
2.3.11. 学术研究机构收集个人信息后，出于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</br>
2.3.12. 法律法规规定的其他情形。</br>

2.4. 来自第三方的信息</br>
2.4.1. 如果我们自第三方获取其所收集的您的信息，我们会通过书面形式要求其说明个人信息来源，以及是否就其收集、处理以及向我们提供您的个人信息获得了您的授权同意。如果我们收集和使用您的信息的目的，超出了第三方已获得的授权范围，我们会自行或要求该第三方另行征得您的同意后再处理您的个人信息。</br>
2.4.2. 若您使用第三方账户登录中升GO，我们可从第三方获取您授权共享的账户信息，并将您的第三方账户与您的中升GO账户绑定，使您可以通过第三方账户直接登录并使用我们的服务。</br>
2.4.3.您了解并同意，以下信息不适用本隐私权政策：</br>
(1) 您在使用中升GO平台提供的搜索服务时输入的关键字信息；</br>
(2) 在您未选择“匿名购买”和/或“匿名评价”功能时，中升GO收集到您在中升GO平台进行交易的有关数据，包括但不限于出价、成交信息及评价详情；</br>
(3) 信用评价、违反法律规定或违反中升GO规则行为及中升GO已对您采取的措施；</br>
(4) 应法律法规要求需公示的企业名称等相关工商注册信息以及自然人经营者的信息。</br>
若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您须确保您已经取得合法的授权。</br>

2.5. 用户信息核验</br>
2.5.1 为了保证您能享受中升GO会员享有的权益，您需授权中升GO平台可以通过第三方来核实手机号码信息。</br>
2.6  平台的第三方SDK调用权限及获取信息</br>

sdk名称 com.qiyukf（七鱼客服SDK）</br>

第三方主体名称: 杭州网易质云科技有限公司</br>

使用目的:用于消息推送，获取设备标识，实现精准推送及聊天信息的推送，并进行关联自启动，仅限于本APP内使用</br>

调用权限及获取信息: 获取网络状态、访问Wi-Fi状态、设备MAC地址、获取BSSID，SSID个人信息、读取手机状态和身份</br></br>
sdk名称com.netease.nis（网易易盾，移动安全联盟；MSA）</br>
第三方主体名称：网易(杭州)网络有限公司</br> 
使用目的:用于一键登录，仅限于本APP内使用</br>
调用权限及获取信息: 获取网络状态、访问Wi-F状态、设备MAC地址、获取BSSID，SSID人信息、读取手机状态和身份</br></br>
sdk名称 cn.jpush.android(极光)</br>
第三方主体名称：极光互动网络技术有限公司</br>
使用目的:用于推送相关咨询消息，仅限于本APP内使用</br>
调用权限及获取信息: 获取网络状态、访问Wi-F状态、设备MAC地址、获取BSSID，SSID人信息、读取手机状态和身份、通知权限</br></br>
sdk名称 cn.jiguang(极光)</br>
第三方主体名称：极光互动网络技术有限公司</br>
使用目的:用于推送相关咨询消息，仅限于本APP内使用</br>
调用权限及获取信息: 获取网络状态、访问Wi-F状态、设备MAC地址、获取BSSID，SSID人信息、读取手机状态和身份、通知权限</br></br>
sdk名称cn.com.chinatelecom(中国电信!天翼)</br>
第三方主题名称：中国电信集团有限公司</br>
使用目的：用于用户一键登录，仅限于本APP内使用</br>
调用权限及获取信息：获取网络状态、访问Wi-F状态、设备MAC地址、获取BSSID，SSID人信息、读取手机状态和身份</br></br>
sdk名称 cn.jpush.android(极光、jpush、和讯华谷)</br>
第三方主体名称：极光互动网络技术有限公司</br>
使用目的:用于推送相关咨询消息和用户分享</br>
调用权限及获取信息: 获取网络状态、访问Wi-F状态、设备MAC地址、获取BSSID，SSID人信息、读取手机状态和身份、通知权限、软件安装列表、ANDROIDID</br></br>
3、 Cookie关联公司及类似技术的使用</br>
3.1. 您理解井同意，为使您获得更轻松的访问体验，您访问中升GO平台或使用中升GO服务时，我们可能会采用各种技术收集和存储相关信息，包括使用小型数据文件识别您的身份，以了解您的使用习惯，帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie、Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”)</br>
3.2. 您理解并同意，我们的某些服务可能只有通过使用Cookie才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝中升GO的Cookie，但拒绝中升GO的Cookie在某些情况下可能会影响您安全访问中升GO平台和使用中升GO服务。</br>
3.3. 您理解并同意，您在访问中升GO平台或使用中升GO服务的过程中可能会存在一些电子图像，称为“单像素 GIF 文件”“网络 beacon”或其他类似技术（统称“网络 beacon”)，它可以帮助网站计算浏览网页的用户或访问某些cookie。我们可能会通过网络beacon收集您浏览网页活动信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境及显示设定等。</br></br>
4、 用户信息的共享、转让和公开披露</br>
4.1. 用户信息的共享</br>
4.1.1.除以下情况外，我们不会将您的个人信息共享给中升GO以外的任何个人、公司或组织：</br>
(1) 依据本政策或事先已获得您明确的同意或授权；</br>
(2) 根据适用的法律、法规、法律程序的要求、行政或司法的强制性要求所必须时；</br>
(3) 在法律、法规允许的范围内，为维护中升GO及关联公司或合作伙伴、您或其他中升GO用户或社会公共利益、财产或安全免遭损害时；</br>
(4）为实现我们的产品和服务的核心功能（积分兑换、网上购物）或提供您需要的服务；</br>
(5）应您的需求为您处理您与他人的纠纷或争议；</br>
(6）根据与您签署的相关协议或其他法律文件的约定；</br>
(7）基于学术研究而使用；</br>
(8) 基于符合法律、法规规定的社会公共利益而使用。</br>

4.1.2. 您充分理解并同意，我们可能会将您的个人信息与我们的关联公司共享。但我们只会共享必要的个人信息，且受本政策中所声明目的的约束。如果我们共享您的个人敏感信息或我们的关联公司要改变个人信息的使用及处理目的，将再次征求您的授权同意。</br>

4.1.3. 您充分理解并同意，我们可能会向合作伙伴或其他第三方共享您的信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定且明确的目的共享您的信息，并且仅共享提供服务所必要的个人信息。我们将与合作伙伴等第三方约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息该等第三方无权将共享的个人信息用于任何其他用途。关于我们接入的合作伙伴等第三方的SDK目录详见此处。</br>

目前，我们的合作伙伴包括以下类型：</br>
(1)广告类合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告类服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。</br>

(2)商品或技术服务的供应商。我们可能会将您的个人信息共享给中升GO商家或物流配送等服务的供应商。我们共享这些信息的目的是可以实现我们产品/服务的核心积分兑换及购物功能或获得技术支持，比如我们必须将您的订单信息及收货信息共享给商家、物流配送服务供应商，以指示其交付商品或提供服务。</br>

4.2.用户信息的转让</br>
除以下情况外，我们不会将您的个人信息转让给任何个人、公司或组织：</br>
4.2.1.事先获得您明确的同意或授权；</br>
4.2.2.根据适用的法律、法规、法律程序的要求、行政或司法的强制性要求所必须时；</br>
4.2.3.根据与您签署的相关协议或其他法律文件的约定；</br>
4.2.4.涉及合作、联营、合并、收购、资产转让或其他类似交易时。</br>

4.3.用户信息的公开披露</br>
中升GO非常重视保护您的个人信息，未经您同意，中升GO不会将其披露给无关的第三方，更不会将其公之于众，但因下列原因而披露的除外：</br>
4.3.1.获得您明确同意或基于您的主动选择；</br>
4.3.2.根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息；</br>
4.3.3.其他依据法律规定或双方约定可以披露的情形。</br>
4.3.4.您理解并同意，根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</br></br>
5、用户个人信息的保护</br>
5.1.数据安全措施</br>
我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受SSL加密保护；我们同时对中升GO网站提供https安全浏览模式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</br>

5.2.我们会采取合理可行的措施以避免收集无关的个人信息。我们只会在达成本政策所述目的所需期限内保留您的个人信息，除非需要延长保留期或应法律法规的允许或要求。您注销中升GO账户或者我们终止服务或运营的，我们将根据第6.4条的规定对您的个人信息进行删除或匿名化处理。</br>

5.3.互联网并非绝对安全的环境，我们强烈建议您在使用中升GO服务时不要使用非中升GO推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</br>

5.4.在使用中升GO服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络中升GO，以便我们根据您的申请采取相应措施。</br>

5.5.特别提醒您注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</br>

5.6.如上述，中升GO将使用各种安全技术、程序和制度防止用户个人信息的丢失、不当使用、未经授权的阅览或披露。但您充分理解并同意：由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。</br>

5.7.在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。若因我们原因导致您的合法权益受损，我们将承担相应的法律责任。</br></br>
6、用户个人信息的保存、跨境传输、删除、访问和管理</br>
6.1.用户个人信息的保存及跨境传输</br>
您的个人信息将全部被存储于中华人民共和国境内，但以下情形除外：</br>
6.1.1.法律法规另有明确规定；</br>
6.1.2.获得您的明确授权；</br>
6.1.3.您通过互联网进行跨境交易等个人主动行为；</br>
6.1.4.针对以上情形，我们会依据本政策及相关法律法规对您的个人信息提供保护。</br>

6.2.用户个人信息的访问</br>
您有权通过以下方式访问您的个人信息，但法律法规另有规定，或本政策、《中升GO用户服务协议》另有约定除外。</br>
6.2.1.账户信息——若您希望访问或编辑您的账户中的个人基本资料等信息，您可登录账号通过“个人中心-我的资料”执行此类操作。</br>
6.2.2.搜索信息——您可登录账号通过“搜索”访问或清除您的搜索记录。</br>
6.2.3.浏览信息——您可登录账号通过“个人中心-历史浏览”访问或清除您的浏览记录。</br>
6.2.4.订单信息：您可登录账号通过“个人中心-我的订单”访问或清除您的订单记录、交易记录等。<br>
6.2.5.若您无法通过上述路径访问该等信息，您可通过中升GO客服与我们联系。对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据第6.7条“响应您的上述请求”中的相关安排向您提供。</br>

6.3.用户个人信息的更正、补充</br>
当您发现您的个人信息有误或需要补充时，您可通过“6.2用户个人信息的访问”中列明的方式提出更正或补充申请。</br>

6.4.用户个人信息的删除</br>
您可通过“6.2用户个人信息的访问”中列明的方式删除您的部分个人信息，但法律、法规规定应当保存的除外。</br>
在以下情形中，您可向我们提出删除个人信息的请求：</br>
(1)我们处理个人信息的行为违反法律法规；</br>
(2)我们收集、使用您的个人信息，却未征得您的明确同意；</br>
(3)我们处理个人信息的行为严重违反了与您的约定；</br>
(4)您注销账户，不再使用我们的产品或服务；</br>
(5)我们永久不再为您提供产品或服务。</br>

6.5.改变您授权同意的范围或撤回您的授权</br>
您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。</br>

请您理解，每个业务功能需要一些基本的个人信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权所进行的信息的收集、处理与使用。</br>

6.6.注销账户</br>
6.6.1.您可在中升GO平台帮助中心-账户相关-账户安全与账户信息-《如何注销中升GO账户》或通过中升GO客户端聊天窗口联系中升GO官方客服，输入“注销”查看注销账户的方式以及您应满足的条件。当您成功申请注销中升GO账户后，我们将在您提出申请后的48小时内完成审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理，法律法规另有规定的除外。</br>
6.6.2.如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</br>
6.7.响应您的上述请求</br>

为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在十五个工作日内做出答复。如您不满意，还可以通过中升GO客服发起投诉。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</br>

6.8.您理解并同意，在以下情形中，按照法律法规的要求，我们将无法响应您的请求：</br>
(1)与国家安全、国防安全有关的；</br>
(2)与公共安全、公共卫生、重大公共利益有关的；</br>
(3)与犯罪侦查、起诉、审判和执行判决等有关的；</br>
(4)有充分证据表明个人信息主体存在主观恶意或滥用权利的；</br>
(5)响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</br>
(6)涉及商业秘密的。</br></br>
7、未成年人信息保护</br>
我们非常重视未成年人的个人信息保护，在电子商务活动中我们推定您具有相应的民事行为能力。若您为18周岁以下的未成年人，请您及您的监护人仔细阅读本政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。</br>

8、其他</br>
8.1. 条款的独立性</br>
如果根据适用的法律认定本政策中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性，这种无效、违法或者不具有可执行性不影响本政策中的任何其它条款或者这些条款中的任何其它部分的效力。</br>

8.2. 联系我们</br>
8.2.1.如您对本隐私政策或您的个人信息的相关事宜有任何问题、意见或建议，请通过中升GO平台的在线客服系统与我们联系。</br>
8.2.2.一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报或来寻求解决方案。</br>

8.3. 生效日期</br>
本政策于 2023年8月27日首次生效。</br>
`,
    };
  },
  components: {},
  mounted() {
    document.title = "隐私协议";
    // this.getActivityContent();
  },
  methods: {},
};
</script>

<style>
.doc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  font-size: 0.24rem;
  padding: 0.2rem 0.12rem;
}
</style>